import type { UseFormReturn } from 'react-hook-form';

import type { SchemaCreditRequestForm } from '../../schemas/creditRequestForm.schema';
import type { LoanType } from '../../types';

type Props = Pick<UseFormReturn<SchemaCreditRequestForm>, 'getValues' | 'reset' | 'setValue'> & {
    creditType: LoanType;
};

export const discardUnsavedCredit = ({ creditType, getValues, reset, setValue }: Props) => {
    const savedCredits = (getValues(creditType) ?? []).filter((credit) => credit.id !== '');
    setValue(creditType, savedCredits as SchemaCreditRequestForm[typeof creditType]);
    reset(getValues(), { keepDirty: false, keepValues: true });
};
